export enum BottomPaginationControlsTestIds {
    LEFT_CONTROL = 'bpc_left',
    RIGHT_CONTROL = 'bpc_right'
}